<template>
  <div class="Testimonial">
    <i class="fab fa-quote">“</i>
    <p class="Testimonial__quote">{{quote}}</p>
    <p class="Testimonial__name">{{name}}</p>
    <p class="Testimonial__company">{{company}}</p>
  </div>
</template>
<script>
export default {
  name: 'Testimonial',
  props: {
    quote: String,
    name: String,
    company: String
  },
  components: {
  },
  computed: {
  },
  mounted () {
  },
  data () {
    return {
    };
  }
};
</script>
<style lang='scss' scoped>
  @import '../scss/colors.scss';

  .Testimonial {
    text-align: center;
    color: $white;

    i {
      font-size: 5em;
    }
  }
</style>
